/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { jsx } from '@atlaskit/css';
import { Inline } from '@atlaskit/primitives/compiled';
import Tooltip from '@atlaskit/tooltip/Tooltip';

import type { PriorityField } from '../../../api/useIssueSearchQuery/types';

export const IssuePriorityNode: ({
	IssuePriorityField,
}: {
	IssuePriorityField: PriorityField;
}) => JSX.Element | null = ({ IssuePriorityField }: { IssuePriorityField: PriorityField }) => {
	if (!IssuePriorityField?.priority) {
		return null;
	}

	return (
		<Inline alignBlock="center" alignInline="start">
			<Tooltip
				content={IssuePriorityField.priority.name}
				// don't need a screen reader announcement as the
				// tooltip content is the same as the items content
				isScreenReaderAnnouncementDisabled
			>
				<img
					height="16"
					width="16"
					src={IssuePriorityField.priority.iconUrl}
					alt={IssuePriorityField.priority.name}
				/>
			</Tooltip>
		</Inline>
	);
};
